import React from 'react'

import { Controller } from 'react-hook-form'

import { FieldErrorText } from './FieldErrorText'
import { FormInputWrapper } from './FormInputWrapper'
import { MaskedInput, MaskedInputProps } from './MaskedInput/MaskedInput'

type Props = React.InputHTMLAttributes<HTMLInputElement> &
  MaskedInputProps & {
    name: string
    rules?: React.ComponentProps<typeof Controller>['rules'] // https://react-hook-form.com/api/useform/register#options
    initialFormattedValue?: string
  }

export function FormMaskedInput({ name, ...props }: Props): React.ReactElement {
  return (
    <FormInputWrapper>
      <MaskedInput name={name} {...props} />
      <FieldErrorText name={name} />
    </FormInputWrapper>
  )
}
